export default [
  {
    path: '/backend/login',
    name: 'backend-login',
    component: () => import('../views/Backend/Auth/Login-Page.vue')
  },
  {
    path: '/backend/password-reset',
    name: 'backend-passwordReset',
    component: () => import('../views/Backend/Auth/PasswordReset-Page.vue')
  },
  {
    path: '/backend/password-forgot',
    name: 'backend-passwordForgot',
    component: () => import('../views/Backend/Auth/PasswordForgot-Page.vue')
  },
  {
    path: '/backend/account-activate',
    name: 'backend-accountActivate',
    component: () => import('../views/Backend/Auth/AccountActivate-Page.vue')
  },
  {
    path: '/backend/invalid',
    name: 'backend-invalid',
    component: () => import('../views/Backend/Error/Error-TokenInvalid.vue')
  }
]
